// 全局参数配置
export default {
  NODE_ENV: process.env.NODE_ENV,
  HTTP_API_URL: process.env.BASE_URL,
  VUE_APP_WECHAT_OFFICIAL_ACCOUNT_SITE: process.env.VUE_APP_WECHAT_OFFICIAL_ACCOUNT_SITE,
  VUE_APP_LOGIN_SITE: process.env.VUE_APP_LOGIN_SITE,
  AH_APP_ID:'wx4027cd4f06265b4c',//安徽新媒正虹微信公众号
  GZ_APP_ID:'wx9bbd808ee34af459'//广州正虹
}



// WEBPACK FOOTER //
// ./src/config/global.js